import React, { JSXElementConstructor, CSSProperties } from 'react';
import clsx from 'clsx';
// utilities
import SanitizeHTMLString from '@/utilities/SanitizeHTMLString';
// interfaces
import TLanguageVersionList from '@/cms/types/TLanguageVersionList';
import TLanguageVersionDetail from '@/cms/types/TLanguageVersionDetail';

type TRMDRComponentSanitizer = {
    variant?: Variant;
    valueExpr?: ValueExpr;
    languageVersion?: TLanguageVersionList|TLanguageVersionDetail|null;

    className?: string;
    style?: CSSProperties;
    extraData?: {[key:string]:string}
    removeTag?:boolean;
}

type Variant = 'p' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'span';
type TcomponentsMap = {[P in Variant]: React.ComponentType<any> | string;}
type ValueExpr = 'name' | 'value';


const componentsMap:TcomponentsMap = {p: 'p', h3: 'h3', h4: 'h4', h1: 'h1', h2: 'h2', div: 'div', span: 'span'};

const RMDRComponentSanitizer = ( props: TRMDRComponentSanitizer ) => {

    const { variant="div", valueExpr="value", languageVersion, className, style } = props;

    const Component: JSXElementConstructor<any> | React.ReactElement<any> | React.ComponentType<any> | string = componentsMap![variant!];

    if ( !languageVersion?.[valueExpr] ) return null;

    if (props.removeTag) {
        const container = document.createElement('div');
        container.innerHTML = SanitizeHTMLString(languageVersion[valueExpr]);
        return  <Component {...props.extraData} className={clsx("ck-content", className)} style={style} dangerouslySetInnerHTML={{__html: (container.firstChild as HTMLElement)?.innerHTML}} />;
    }

    return  <Component {...props.extraData} className={clsx("ck-content", className)} style={style} dangerouslySetInnerHTML={{__html: languageVersion[valueExpr]}} />;

}

export default RMDRComponentSanitizer;
export type {
    TRMDRComponentSanitizer
};